import { Entry } from './entry';

export interface Any {
  any: Entry[];
}

export function isAny(rule: Entry): rule is Any {
  return Object.prototype.hasOwnProperty.call(rule, 'any');
}
